// outline blue button

import React from "react";
import { LineDownSvg, LineDownWhiteSvg } from "../Assets";
export default function BackBtn({ children, onClick, size = 24, isWhite = false }) {
  // button with arrow image
  return (
    <button className="flex items-center" onClick={onClick}>
      {children}
      <img
        src={isWhite ? LineDownWhiteSvg : LineDownSvg}
        alt="arrow"
        style={{ width: `${size}px`, height: `${size}px` }}
      />
    </button>
  );
}